import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { label: "About", href: "#about", id: "about" },
  { label: "Services", href: "#services", id: "services" },
  { label: "Team", href: "#team", id: "team" },
  { label: "Reviews", href: "#reviews", id: "reviews" },
  { label: "Contact", href: "#contact", id: "contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow] duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-xl shadow-[0_1px_0_rgba(10,10,10,0.08)]" : "bg-white/0"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Logo light={!scrolled} />
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-${l.id}-link`}
              className={`text-xs font-bold tracking-[0.2em] uppercase transition-colors duration-200 hover:text-electric ${
                scrolled ? "text-ink/80" : "text-white/85"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#book"
            data-testid="nav-book-cta"
            className={`ml-2 inline-flex items-center rounded-full text-white text-xs font-bold tracking-[0.15em] uppercase px-6 py-3 transition-colors duration-300 ${
              scrolled ? "bg-navy hover:bg-electric" : "bg-electric hover:bg-white hover:text-navy"
            }`}
          >
            Book Appointment
          </a>
        </nav>
        <button
          data-testid="mobile-menu-button"
          onClick={() => setOpen(!open)}
          className={`md:hidden p-2 ${scrolled ? "text-ink" : "text-white"}`}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white/95 backdrop-blur-xl border-t border-black/5 overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <a
                  key={l.id}
                  href={l.href}
                  data-testid={`mobile-nav-${l.id}-link`}
                  onClick={() => setOpen(false)}
                  className="text-sm font-semibold tracking-[0.2em] uppercase text-ink/80"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#book"
                data-testid="mobile-nav-book-cta"
                onClick={() => setOpen(false)}
                className="inline-flex items-center justify-center rounded-full bg-navy text-white text-xs font-bold tracking-[0.15em] uppercase px-6 py-3"
              >
                Book Appointment
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
